export class LightTheme {
	public static styles: google.maps.MapTypeStyle[] = [];
}
